var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tiptap-inline-blank d-inline-flex align-items-center bg-light border rounded"},[_c('small',{staticClass:"blank-id text-muted"},[_vm._v(" "+_vm._s(_vm.blank_id)+". ")]),_vm._v(" ___ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }